import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
 
const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.validacion} dato2={props.elemento._id}>{props.elemento.descrPrueba}</option>
  )
};

const ListaPR = ({handleLista, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrPrueba" id="miLista" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivel2 = props => {
  return (
    <option dato1={props.elemento.tipoLub}>{props.elemento.descrAplicacion}</option>
  )
};

const ListaAP = ({handleLista, list}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrAplicacion" id="miLista1" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

// const AddpruebasLab2 = ({styles, list, list1, handleLista, handleLista1, handleSubmit, handleChange, args, errors}) => {
//class AddpruebasLab2  extends React.Component {

class AddpruebasLab2 extends React.Component {
  state={
    argsDocum: {
      validacion: "Seleccionar..."
    }
  }

  render(){
    const {argsDocum} = this.state;

    let listAp=[]
    let tipoL='Aceite' 
    listAp = this.props.list1.filter(elemento => elemento.tipoLub===tipoL)

    return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Asociar pruebas de laboratorio
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, this.props.args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={this.props.styles.label}>Prueba</label>
                  <ListaPR list={this.props.list} handleLista={this.props.handleLista} />
                </Form.Field>                     
                <Form.Field>
                  <label style={this.props.label}>Aplicación</label>
                  <ListaAP list={listAp} handleLista={this.props.handleLista1} />
                </Form.Field>      
                <Form.Field>
                  <label style={this.props.styles.label}>Valor 1 Alarma</label>
                  <input type='number' step="0.01" autoComplete="off" name="valor1Alarma" id="valor1Alarma" placeholder='Valor 1 Alarma' onChange={this.props.handleChange}/>
                </Form.Field>
                {this.props.args.validacion==='Rango de % en Aceite nuevo' &&
                <div>                                
                  <Form.Field>
                    <label style={this.props.styles.label}>Valor 2 Alarma</label>
                    <input type='number' step="0.01" autoComplete="off" name="valor2Alarma" id="valor2Alarma" placeholder='Valor 2 Alarma' onChange={this.props.handleChange}/>
                  </Form.Field>
                </div>
                }  
                {this.props.args.validacion==='Mayor que 3 valores de referencia' &&
                <div>   
                  <Form.Field>
                    <label style={this.props.styles.label}>Valor 2 Alarma</label>
                    <input type='number' step="0.01" autoComplete="off" name="valor2Alarma" id="valor2Alarma" placeholder='Valor 2 Alarma' onChange={this.props.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Valor 3 Alarma</label>
                    <input type='number' step="0.01" autoComplete="off" name="valor3Alarma" id="valor3Alarma" placeholder='Valor 3 Alarma' onChange={this.props.handleChange}/>
                  </Form.Field> 
                </div>
                }                               
                <Form.Field>
                  <label style={this.props.styles.label}>Valor 1 Corte</label>
                  <input type='number' step="0.01" autoComplete="off" name="valor1Corte" id="valor1Corte" placeholder='Valor 1 Corte' onChange={this.props.handleChange}/>
                </Form.Field>                                
                {this.props.args.validacion==='Rango de % en Aceite nuevo' &&
                <div>                                
                  <Form.Field>
                    <label style={this.props.styles.label}>Valor 2 Corte</label>
                    <input type='number' step="0.01" autoComplete="off" name="valor2Corte" id="valor2Corte" placeholder='Valor 2 Corte' onChange={this.props.handleChange}/>
                  </Form.Field>                
                </div>
                }
                {this.props.args.validacion==='Mayor que 3 valores de referencia' &&
                <div>   
                  <Form.Field>
                    <label style={this.props.styles.label}>Valor 2 Corte</label>
                    <input type='number' step="0.01" autoComplete="off" name="valor2Corte" id="valor2Corte" placeholder='Valor 2 Corte' onChange={this.props.handleChange}/>
                  </Form.Field>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Valor 3 Corte</label>
                    <input type='number' step="0.01" autoComplete="off" name="valor3Corte" id="valor3Corte" placeholder='Valor 3 Corte' onChange={this.props.handleChange}/>
                  </Form.Field>                                                                
                </div>
                }                                
              </div>    
            </div>
          </div>
          <hr></hr>
            <Button style={this.props.styles.confirmar} type='submit' fluid>
              AGREGAR
            </Button>

            {
              // this.props.errors.length?<Message negative header="Los siguientes errores:"
              // list={this.props.errors.map(error=>`${this.props.error.path}: ${error.message}`)} />:null
            }

        </Form>
      </div>
    </div>
  )
}
}


export default AddpruebasLab2
